import { RiCameraLine } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type React from "react";
import type { ReactNode } from "react";
import type { DealReportImage } from "~/models/DealReportImage";
import Styles from "./ReportImageNavigation.module.scss";

type Props = {
	detailPageButtonLabel: string;
	detailPagePath: string;
	optionalLabel?: boolean;
	reportImages: DealReportImage[];
	title: string;
};

export const ReportImageNavigation: React.FC<Props> = ({
	title,
	detailPagePath,
	detailPageButtonLabel,
	reportImages,
	optionalLabel = false
}: Props) => {
	const thumbnailImages = reportImages.filter(
		(i: DealReportImage) => i.thumbnailImageUrl !== null
	);
	// 4枚までサムネイルに表示
	const thumbnailCount =
		thumbnailImages.length > 3 ? 3 : thumbnailImages.length;
	const additionalImageCount = reportImages.length - thumbnailCount;
	return (
		<div className={Styles.NavigationBlock}>
			<div className={Styles.IconWrapper}>
				<RiCameraLine className={Styles.Icon} />
			</div>
			<div className={Styles.NavigationContent}>
				<div>
					<h4 className={Styles.Title}>
						{title}
						{optionalLabel ? (
							<span className={Styles.OptionalLabel}>任意</span>
						) : null}
					</h4>
					<div className={Styles.SpImageCount}>
						{reportImages.length}件の画像が登録されています
					</div>
					{thumbnailImages.length > 0 && (
						<div className={Styles.ThumbnailImageList}>
							{[...Array(thumbnailCount)].map(
								(_num: number, i: number): ReactNode => (
									<img
										alt="thumbnail"
										className={Styles.ThumbnailImage}
										key={thumbnailImages[i].id}
										src={thumbnailImages[i].thumbnailImageUrl ?? ""}
									/>
								)
							)}
							{additionalImageCount > 0 && (
								<div className={Styles.AdditionalImageCountBlock}>
									+{additionalImageCount}
								</div>
							)}
						</div>
					)}
					{reportImages.length === 0 && (
						<div className={Styles.NotYet}>画像は登録されていません</div>
					)}
				</div>
				<div className={Styles.DetailLinkBlock}>
					<Link className={Styles.DetailLink} href={detailPagePath}>
						{detailPageButtonLabel}
					</Link>
				</div>
			</div>
		</div>
	);
};
